import { useState, useEffect } from 'react';
import ProductsService from '../services/ProductsService/ProductsService';

interface UseFeaturedProductsResult {
  hasFeaturedProducts: boolean;
  loading: boolean;
}

/**
 * Hook que verifica se existem produtos em destaque válidos
 * (com SKU e estoque > 0) para o cliente
 */
export const useFeaturedProducts = (
  clientCode: string | undefined,
): UseFeaturedProductsResult => {
  const [hasFeaturedProducts, setHasFeaturedProducts] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkFeaturedProducts = async () => {
      if (!clientCode) {
        setHasFeaturedProducts(false);
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        const response = await ProductsService.featuredProductsGet(
          clientCode,
          10, // Buscar apenas alguns para validar
          1,
        );

        // Normalizar resposta (pode vir como objeto com chaves numéricas)
        let rawData: any = response?.data;
        if (rawData && !Array.isArray(rawData) && typeof rawData === 'object') {
          rawData = Object.values(rawData);
        }

        if (rawData && Array.isArray(rawData)) {
          // Filtrar produtos válidos: com estoque > 0
          // Agora os produtos vêm no formato ProductDTO direto do backend
          const validProducts = rawData.filter((item: any) => {
            // Verificar se tem SKU e estoque válido
            return item && item.sku && item.estoque && Number(item.estoque) > 0;
          });

          setHasFeaturedProducts(validProducts.length > 0);
        } else {
          setHasFeaturedProducts(false);
        }
      } catch (error) {
        console.error('Error checking featured products:', error);
        setHasFeaturedProducts(false);
      } finally {
        setLoading(false);
      }
    };

    checkFeaturedProducts();
  }, [clientCode]);

  return { hasFeaturedProducts, loading };
};
